import React from "react";
import Container from "@/components/foundation/Container";
import Card from "@/components/foundation/Card";
import FadeIn from "@/components/foundation/FadeIn";
import PartnerLink from "@/components/marketing/PartnerLink";

/**
 * TrustBar — two brand-critical partner lockups displayed prominently.
 * Kept intentionally minimal so Mastercard Finicity and Uptiq AI carry the
 * "who powers us" message on their own. The partner name lockups are now
 * anchored to each partner's real website.
 */
export const TrustBarSection = () => {
  return (
    <section
      className="relative border-y border-white/[0.05] bg-bg-raised py-20 sm:py-24"
      data-testid="trust-bar-section"
    >
      <Container>
        <FadeIn>
          <p className="text-center font-mono text-[11px] uppercase tracking-[0.24em] text-text-muted">
            Trusted Financial Infrastructure
          </p>
        </FadeIn>

        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
          <FadeIn delay={0.05}>
            <Card
              variant="flat"
              className="flex h-full items-center justify-center px-8 py-10 sm:py-12"
              data-testid="trust-mastercard"
            >
              <div className="flex flex-col items-center gap-2 text-center">
                <span className="text-[11px] uppercase tracking-[0.16em] text-text-muted">
                  Powered by
                </span>
                <PartnerLink
                  partner="finicity"
                  underline="hover"
                  showGlyph={false}
                  className="!inline-flex !items-baseline !gap-2 font-display text-2xl font-semibold !text-white sm:text-3xl"
                >
                  <span>Mastercard</span>
                  <span aria-hidden="true" className="text-brand-emerald">·</span>
                  <span>Finicity</span>
                </PartnerLink>
                <span className="mt-1 text-xs text-text-secondary">
                  Secure open-banking connectivity
                </span>
              </div>
            </Card>
          </FadeIn>

          <FadeIn delay={0.1}>
            <Card
              variant="flat"
              className="flex h-full items-center justify-center px-8 py-10 sm:py-12"
              data-testid="trust-uptiq"
            >
              <div className="flex flex-col items-center gap-2 text-center">
                <span className="text-[11px] uppercase tracking-[0.16em] text-text-muted">
                  Built with
                </span>
                <PartnerLink
                  partner="uptiq"
                  underline="hover"
                  showGlyph={false}
                  className="!inline-flex !items-center !gap-2 font-display text-2xl font-semibold !text-white sm:text-3xl"
                >
                  <span>Uptiq AI</span>
                  <span
                    aria-hidden="true"
                    className="inline-block h-1.5 w-1.5 rounded-full bg-brand-emerald shadow-[0_0_8px_rgba(0,230,118,0.7)]"
                  />
                </PartnerLink>
                <span className="mt-1 text-xs text-text-secondary">
                  AI/ML infrastructure powering ZenScore
                </span>
              </div>
            </Card>
          </FadeIn>
        </div>
      </Container>
    </section>
  );
};

export default TrustBarSection;
